var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFaceWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "80px",
    viewBox: "0 0 70 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.996,75.677c-3.176-1.434-6.814-1.434-9.99,0c0-1.862,0-3.724,0-5.586c3.176-1.434,6.814-1.434,9.99,0 C39.996,71.953,39.996,73.814,39.996,75.677z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.033,
    y1: 39.25,
    x2: 35.033,
    y2: 20.077
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.345,
    y1: 26.8,
    x2: 38.198,
    y2: 24.814
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.502,
    y1: 23.644,
    x2: 40.515,
    y2: 22.497
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 43.657,
    y1: 19.333,
    x2: 41.362,
    y2: 19.333
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.502,
    y1: 15.02,
    x2: 40.515,
    y2: 16.167
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.345,
    y1: 11.864,
    x2: 38.198,
    y2: 13.851
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 35.033,
    cy: 19.332,
    r: 3.164
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.033,
    y1: 10.708,
    x2: 35.033,
    y2: 13.002
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.721,
    y1: 26.8,
    x2: 31.869,
    y2: 24.814
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.564,
    y1: 23.644,
    x2: 29.552,
    y2: 22.497
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.41,
    y1: 19.333,
    x2: 28.704,
    y2: 19.333
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.564,
    y1: 15.02,
    x2: 29.552,
    y2: 16.167
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.721,
    y1: 11.864,
    x2: 31.869,
    y2: 13.851
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.033,
    y1: 10.708,
    x2: 35.033,
    y2: 13.002
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.561,53.821c0,2.499-2.044,4.543-4.542,4.543h-3.201c-2.499,0-4.542-2.044-4.542-4.543v-6.553 c0-2.499,2.044-4.542,4.542-4.542h3.201c2.499,0,4.542,2.044,4.542,4.542V53.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.561,53.821c0,2.499-2.044,4.543-4.542,4.543h-3.201c-2.499,0-4.542-2.044-4.542-4.543v-6.553c0-2.499,2.044-4.542,4.542-4.542 h3.201c2.499,0,4.542,2.044,4.542,4.542V53.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M59.792,53.821c0,2.499-2.044,4.543-4.542,4.543h-3.201c-2.499,0-4.542-2.044-4.542-4.543v-6.553 c0-2.499,2.044-4.542,4.542-4.542h3.201c2.499,0,4.542,2.044,4.542,4.542V53.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M59.792,53.821c0,2.499-2.044,4.543-4.542,4.543h-3.201c-2.499,0-4.542-2.044-4.542-4.543v-6.553c0-2.499,2.044-4.542,4.542-4.542 h3.201c2.499,0,4.542,2.044,4.542,4.542V53.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.03,65.125c0,2.322-1.9,4.222-4.222,4.222h-29.55c-2.322,0-4.222-1.899-4.222-4.222v-29.55 c0-2.322,1.9-4.222,4.222-4.222h29.55c2.322,0,4.222,1.9,4.222,4.222V65.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M54.03,65.125c0,2.322-1.9,4.222-4.222,4.222h-29.55c-2.322,0-4.222-1.899-4.222-4.222v-29.55c0-2.322,1.9-4.222,4.222-4.222 h29.55c2.322,0,4.222,1.9,4.222,4.222V65.125z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 45,
    height: 159,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAACjCAYAAADIBU1XAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZFJREFUeNrs3UFKw0AUgOHGCF0F 9QIi3v9MIl5AJbuubKSK0GqIZpz3pt+AqGglX/95Y3WTzcayiqxu6QPub++G/bvhxJfGh6fHsRbk cgVAiHXRAmK2SAbAoiKpIZlqfAvJhmh7a2Ws0W6RrDXO4/gFAYkBqfoSXhEQEBAQEBCQ02s4/C2j CAgICAgICAgICAgICAgICMjcqvqfFEVAQEBAQEBAzgBS7fWWIiAgICAg0SBVfikqAgICAlLlCFYE BAQk18mlCAgISK6TSxEQkPqQfxl4RUBAYkCKD7wiICBxIEUHXhGQRiDF5kQRkIYgReZEEZBC20sR kAYhq86JIiCFtpciIIW2lyIghbaXIiCFtpci0aooAlJoeykSrYoiIIW2lyLRqigSrUozRfqvnzy/ vuxurq6nD7fBrnM7Xdd0fWYky6wcQQ53PxpTz0jmWWnz1Mpc5ccimealn/uGoGWOqiy6ZXPAGz9+ 3mOuX/Ko6RnYv42BCu0+qnR/+SlBCr1X6SIN7C+fmOq3MFx1vQkwAPYaXqabIsWrAAAAAElFTkSu QmCC",
    transform: "matrix(0.24 0 0 0.24 16.0361 31.4946)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAABDCAYAAABgFw6IAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO1JREFUeNrs1sEKwjAMBuCtSndU 0fMYe/9nGmNni3oR9KQHlWKjazvyy+TPcZR9SdOWlEVitHWzi13bDf1e+l5mYDYhx6sELxJAG7ve //9mta4Op+M5CfXA3AhgowwWUksMAAzCxGanjqZci5yrZoDbakVUs4/i9qLAF4oE/Uph4OjjQJQo 0QDVeNxjKrXsKVGiRIkSJTob1MHRbugv7CnR/0AdHPXvD3tKdJaog6Poa8ODBEMdHH0cJofAzfvw 5OHYnmpXbb6NjFpVj55ejaqXKYNyWzcSvFVBpSn9GR8SmZzY5LgnVhW/jpsAAwAaRFBDVYaR+AAA AABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 10.2075 42.8105)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAYAAABfeMd1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQxJREFUeNrcluEKwiAQx925EQij eoGI3v+ZInqBimhftrG8cYSt6c7TfengGJvzfv7/KqrUv0QRajwdjto+SnrtztdLL4GUC4DapqFP T8roACYgKWBtwA9kDcCcEhMAaBqEHEIFQkWMVCHkKCJaXYEQWRYLEakFgfpoNRJItBoQzmWUGikE ldRcECSsTLZtkLgFWLalQli2QYYNvQj6NOy3OzzAKiF47GdrDDbV7XEfZiG2obU/IGAjVFSRKoS1 Lmg66p4yq31fPpKaIcG2qX2josJzxhs6IXWiqgYvH7NFMirCvr13pA4IIpc7zmlHz5e9qzUFpxfZ Z5x51IEF02Bh9g2SAVS+wm68BRgA+/hJKU6+bN4AAAAASUVORK5CYII=",
    transform: "matrix(0.24 0 0 0.24 31.7793 16.438)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.3839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.996,
    y1: 70.091,
    x2: 39.996,
    y2: 75.677
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.3839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.006,
    y1: 75.677,
    x2: 30.006,
    y2: 70.091
  }), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAdCAYAAADVV140AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIFJREFUeNrs2EEKgCAQQFEnZusV Irr/mSK6wlygFtEiisy0lP5sXCnvbwR1rtKRmE192/ll8YktNkyjJYVngj4KkcKwwRFSOPg0QipD b/im1lsFOHDgwIEDBw4cOHDgwP8D19zfCFcT+87VN5FHs55nd0P0C2yKEC0BGxKyD5gFGADwUzc7 y+qlggAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 30.0059 69.0156)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.532,58.857c0,1.127-1.235,2.05-2.744,2.05H28.279c-1.509,0-2.744-0.923-2.744-2.05 s1.235-2.05,2.744-2.05h13.509C43.297,56.808,44.532,57.73,44.532,58.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M44.532,58.857c0,1.127-1.235,2.05-2.744,2.05H28.279c-1.509,0-2.744-0.923-2.744-2.05s1.235-2.05,2.744-2.05h13.509 C43.297,56.808,44.532,57.73,44.532,58.857z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.29,
    y1: 57.446,
    x2: 30.29,
    y2: 60.38
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.034,
    y1: 57.446,
    x2: 35.034,
    y2: 60.38
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.778,
    y1: 57.446,
    x2: 39.778,
    y2: 60.38
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 26.064,46.449 29.898,48.121 26.334,49.923  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 44.004,46.449 40.17,48.121 43.734,49.923  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.072,
    y1: 42.811,
    x2: 29.906,
    y2: 43.555
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 40.907,
    y1: 43.555,
    x2: 43.996,
    y2: 42.811
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFaceWorking);
export default __webpack_public_path__ + "static/media/ai-face-working.afa947d80dbe04b0f5c34dfffba92e30.svg";
export { ForwardRef as ReactComponent };